import './FreelanceSearchFilterSidebar.scss'

import {Component} from 'react'
import PropTypes from 'prop-types'
import {Input} from 'reactstrap'
import {toastr} from 'react-redux-toastr'
import {
  Archive,
  Briefcase,
  Calendar,
  ChevronDown,
  Compass,
  DollarSign,
  Filter,
  Globe,
  Key,
  List,
  MessageSquare,
  Monitor,
  Save,
  User,
  X,
} from 'react-feather'

import api from '../../../../../../api.js'
import FilterAvailability from '../../../../../../shared/components/FilterBar/components/FilterAvailability/FilterAvailability.jsx'
import FilterCity from '../../../../../../shared/components/FilterBar/components/FilterCity/FilterCity.jsx'
import FilterDistance from '../../../../../../shared/components/FilterBar/components/FilterDistance/FilterDistance.jsx'
import FilterExperience from '../../../../../../shared/components/FilterBar/components/FilterExperience/FilterExperience.jsx'
import FilterItSkills from '../../../../../../shared/components/FilterBar/components/FilterItSkills/FilterItSkills.jsx'
import FilterLanguages from '../../../../../../shared/components/FilterBar/components/FilterLanguages/FilterLanguages.jsx'
import FilterManager from '../../../../../../shared/components/FilterBar/components/FilterManager/FilterManager.jsx'
import FilterPrices from '../../../../../../shared/components/FilterBar/components/FilterPrices/FilterPrices.jsx'
import FilterSecteur from '../../../../../../shared/components/FilterBar/components/FilterSecteur/FilterSecteur.jsx'
import FreelanceFilterType from '../../../../../../shared/components/FilterBar/components/FilterType/FreelanceFilterType.jsx'
import SearchInput from '../../../../../components/SearchBar/components/SearchInput/SearchInput.jsx'
import UserSavedFilter from '../../../../../../shared/components/FilterBar/components/UserSavedFilter/UserSavedFilter.jsx'

import {
  AVAILABILITY_FILTER_KEY,
  CITY_FILTER_KEY,
  DISTANCE_FILTER_KEY,
  IT_SKILLS_FILTER_KEY,
  LANGUAGE_FILTER_KEY,
  MANAGER_FILTER_KEY,
  MY_APPLICATION_FILTER_KEY,
  NB_YEAR_OF_EXPERIENCE_FILTER_KEY,
  PRICE_MAX_FILTER_KEY,
  PRICE_MIN_FILTER_KEY,
  RELOCATION_FILTER_KEY,
  SECTEUR_FILTER_KEY,
  UNIVERSE_FILTER_KEY,
} from '../../../../../../shared/constants/filters.js'

const GOLD_TOPOLOGY_NAME = 'gold'

class FilterSection extends Component {
  static propTypes = {
    icon: PropTypes.elementType.isRequired,
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    defaultOpen: PropTypes.bool,
  }

  static defaultProps = {
    defaultOpen: false,
  }

  state = {
    open: this.props.defaultOpen,
  }

  toggle = () => {
    this.setState((prevState) => ({open: !prevState.open}))
  }

  render() {
    const {icon: Icon, title, children} = this.props
    const {open} = this.state

    return (
      <div className="filter-section">
        <button type="button" className="filter-section__title" onClick={this.toggle}>
          <Icon size={22} />
          <span className="filter-section__title-label">{title}</span>
          <ChevronDown size={18} className={`filter-section__chevron${open ? ' filter-section__chevron--open' : ''}`} />
        </button>
        {open && (
          <div className="filter-section__content">
            {children}
          </div>
        )}
      </div>
    )
  }
}

export default class FreelanceSearchFilterSidebar extends Component {
  static propTypes = {
    conf: PropTypes.object.isRequired,
    currentUniverseId: PropTypes.number,
    currentUser: PropTypes.object,
    filters: PropTypes.object.isRequired,
    isAdmin: PropTypes.bool,
    isSecteurs: PropTypes.bool,
    isLanguages: PropTypes.bool,
    isItSkills: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    searchQuery: PropTypes.object.isRequired,
    topologies: PropTypes.array,
    userMainUniverseId: PropTypes.number,
  }

  static defaultProps = {
    currentUniverseId: null,
    currentUser: null,
    isAdmin: false,
    isSecteurs: false,
    isLanguages: false,
    isItSkills: false,
    topologies: [],
    userMainUniverseId: null,
  }

  constructor(props) {
    super(props)
    this.state = {
      mobileOpen: false,
      savedFilterName: '',
      draft: {},
      universes: [],
      savedFiltersRefreshToken: 0,
    }
  }

  componentDidMount() {
    api.universes.getAll()
      .then((response) => {
        if (response.data) {
          this.setState({universes: response.data})
        }
      })
      .catch((error) => console.error({error}))
  }

  toggleMobile = () => {
    this.setState((prevState) => ({mobileOpen: !prevState.mobileOpen}))
  }

  updateDraft = (data) => {
    this.setState((prevState) => ({draft: {...prevState.draft, ...data}}))
  }

  handleSubmit = () => {
    this.props.onChange(this.state.draft)
  }

  getSearchPlaceholder = (effective) => {
    const requirementsSelected = effective?.requirements ? parseInt(effective.requirements, 10) : null

    if (!requirementsSelected) return 'Rechercher une compétence'
    if (requirementsSelected === 1) return 'Rechercher un ID'
    if (requirementsSelected === 2) return 'Rechercher un Nom / Prénom'
    if (requirementsSelected === 3) return 'Rechercher un Email'
    if (requirementsSelected === 4) return 'Rechercher un Téléphone'
    if (requirementsSelected === 5) return 'Rechercher un Commentaire'
    return 'Rechercher ...'
  }

  handleRequirementsChange = (value) => {
    const resets = {}
    this.props.topologies.forEach((topology) => {
      if (topology.name) resets[topology.name] = null
    })
    if (!value) {
      Object.assign(resets, {active: 1, cdi: 0, complete: 1})
    }
    this.updateDraft({...resets, requirements: value})
  }

  handleReset = () => {
    const {onChange, searchQuery, topologies} = this.props
    const data = searchQuery

    delete data[CITY_FILTER_KEY]
    delete data.latitude
    delete data.longitude
    delete data[RELOCATION_FILTER_KEY]
    delete data[DISTANCE_FILTER_KEY]
    delete data[MANAGER_FILTER_KEY]
    delete data[MY_APPLICATION_FILTER_KEY]
    delete data[NB_YEAR_OF_EXPERIENCE_FILTER_KEY]
    delete data[AVAILABILITY_FILTER_KEY]
    delete data[LANGUAGE_FILTER_KEY]
    delete data[SECTEUR_FILTER_KEY]
    delete data[IT_SKILLS_FILTER_KEY]
    delete data[PRICE_MIN_FILTER_KEY]
    delete data[PRICE_MAX_FILTER_KEY]

    topologies.forEach((topology) => {
      if (topology.name && data[topology.name]) {
        delete data[topology.name]
      }
    })

    this.setState({draft: {}})
    onChange(data)
  }

  onSavedFilterNameChange = (event) => {
    const {value} = event.currentTarget
    this.setState({savedFilterName: value ? value : ''})
  }

  onSaveFilter = async () => {
    const {searchQuery} = this.props
    const {limit, page, ...dataToSave} = searchQuery
    const dataToSaveStr = new URLSearchParams(dataToSave).toString()

    await api.freelances.saveSearch({
      name: this.state.savedFilterName,
      filters: dataToSaveStr
    }).then(() => {
      toastr.success(`Le filtre s'est correctement enregistré`)
      this.setState((prevState) => ({savedFilterName: '', savedFiltersRefreshToken: prevState.savedFiltersRefreshToken + 1}))
    }).catch((error) => {
      console.error({error})
      toastr.error('Une erreur est survenue')
    })
  }

  render() {
    const {
      conf, currentUniverseId, currentUser, filters, isAdmin, isSecteurs, isLanguages, isItSkills,
      searchQuery, topologies, userMainUniverseId,
    } = this.props
    const {mobileOpen, savedFilterName, draft, universes, savedFiltersRefreshToken} = this.state

    const effective = {...searchQuery, ...draft}
    const topologiesWithoutGold = topologies.filter((topology) => topology.name !== GOLD_TOPOLOGY_NAME)

    const selectedUniverse = effective?.[UNIVERSE_FILTER_KEY] ?? (currentUniverseId ?? userMainUniverseId)
    const availableUniversesOptions = universes.map((universe) => ({value: universe.id, text: universe.name}))

    return (
      <div className="freelance-search-filter-sidebar">
        <button
          type="button"
          className="freelance-search-filter-sidebar__mobile-toggle btn btn-secondary btn-auto-width"
          onClick={this.toggleMobile}
        >
          <Filter size={18} />
          Filtres
        </button>

        {mobileOpen && (
          <div className="freelance-search-filter-sidebar__overlay" onClick={this.toggleMobile} />
        )}

        <div className={`freelance-search-filter-sidebar__inner${mobileOpen ? ' freelance-search-filter-sidebar__inner--open' : ''}`}>
          <div className="freelance-search-filter-sidebar__header">
            <h2>Filtres</h2>

            <button type="button" className="btn-reset" onClick={this.handleReset}>
              Réinitialiser
            </button>

            <button
              type="button"
              className="freelance-search-filter-sidebar__close btn-auto-width"
              onClick={this.toggleMobile}
            >
              <X size={20} />
            </button>
          </div>

          <div className="freelance-search-filter-sidebar__body">
            <FilterSection icon={Key} title="Mots clés" defaultOpen={true}>
              <Input
                type="select"
                value={effective?.requirements ?? ''}
                onChange={(event) => this.handleRequirementsChange(event.target.value === '' ? undefined : parseInt(event.target.value, 10))}
              >
                {(filters?.requirementChoices?.length ? filters.requirementChoices : []).map((choice) => (
                  <option value={choice.value ?? ''} key={choice.text}>{choice.text}</option>
                ))}
              </Input>

              <div className="freelance-search-filter-sidebar__search-input">
                <SearchInput
                  className="input-search"
                  value={effective?.keywords?.length ? effective.keywords : []}
                  onChange={(newVal) => this.updateDraft({keywords: newVal})}
                  placeholder={this.getSearchPlaceholder(effective)}
                />
              </div>
            </FilterSection>

            <FilterSection icon={Globe} title="Univers" defaultOpen={true}>
              <Input
                type="select"
                value={selectedUniverse ?? ''}
                onChange={(event) => this.updateDraft({[UNIVERSE_FILTER_KEY]: parseInt(event.target.value, 10)})}
              >
                {availableUniversesOptions.map((choice) => (
                  <option value={choice.value} key={choice.value}>{choice.text}</option>
                ))}
              </Input>
            </FilterSection>

            <FilterSection icon={List} title="Topologie" defaultOpen={true}>
              <div className="freelance-search-filter-sidebar__topology">
                <FreelanceFilterType
                  topologies={topologiesWithoutGold}
                  searchQuery={effective}
                  onChange={this.updateDraft}
                />
              </div>
            </FilterSection>

            <FilterSection icon={Compass} title="Localisation">
              <FilterDistance
                distance={effective?.[DISTANCE_FILTER_KEY]}
                onChange={(data = {}) => this.updateDraft(data)}
              />
              <FilterCity
                city={effective?.city ?? null}
                relocation={String(effective?.[RELOCATION_FILTER_KEY]) === '1'}
                onChange={(data = {}) => this.updateDraft(data)}
                onChecked={(data) => this.updateDraft({relocation: data ? 1 : 0})}
                isRemote={true}
              />
            </FilterSection>

            <FilterSection icon={Calendar} title="Disponibilité">
              <FilterAvailability
                value={parseInt(effective?.availability ?? 0, 10)}
                onChange={(data) => this.updateDraft({availability: data})}
              />
            </FilterSection>

            {isAdmin && (
              <FilterSection icon={DollarSign} title="TJM">
                <FilterPrices
                  priceMin={effective?.[PRICE_MIN_FILTER_KEY] ?? null}
                  priceMax={effective?.[PRICE_MAX_FILTER_KEY] ?? null}
                  onChange={(data) => this.updateDraft(data)}
                />
              </FilterSection>
            )}

            <FilterSection icon={Archive} title="Durée d'expérience">
              <FilterExperience
                conf={conf}
                experiences={effective?.nbYearOfExperience?.length ? effective.nbYearOfExperience : []}
                onChange={(data) => this.updateDraft({nbYearOfExperience: data})}
              />
            </FilterSection>

            {isSecteurs && (
              <FilterSection icon={Briefcase} title="Secteur">
                <FilterSecteur
                  value={effective?.[SECTEUR_FILTER_KEY]}
                  onChange={(data) => this.updateDraft(data)}
                />
              </FilterSection>
            )}

            {isLanguages && (
              <FilterSection icon={MessageSquare} title="Langue">
                <FilterLanguages
                  value={effective?.[LANGUAGE_FILTER_KEY]?.length ? effective[LANGUAGE_FILTER_KEY] : []}
                  onChange={(data) => this.updateDraft(data)}
                />
              </FilterSection>
            )}

            {isItSkills && (
              <FilterSection icon={Monitor} title="Outil informatique">
                <FilterItSkills
                  value={effective?.[IT_SKILLS_FILTER_KEY]?.length ? effective[IT_SKILLS_FILTER_KEY] : []}
                  onChange={(data) => this.updateDraft(data)}
                  requireSubmit={false}
                />
              </FilterSection>
            )}

            <FilterSection icon={User} title="Responsable">
              <FilterManager
                value={effective?.manager}
                onChange={(data) => this.updateDraft(data)}
              />
            </FilterSection>

            <FilterSection icon={Save} title="Filtres sauvegardés">
              <UserSavedFilter className="filter" refreshToken={savedFiltersRefreshToken} />
              <div className="freelance-search-filter-sidebar__saved-filter-save">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nom du filtre"
                  value={savedFilterName}
                  onChange={this.onSavedFilterNameChange}
                />
                <button
                  type="button"
                  className="btn btn-secondary"
                  disabled={!savedFilterName}
                  onClick={this.onSaveFilter}
                >
                  OK
                </button>
              </div>
            </FilterSection>
          </div>

          <div className="freelance-search-filter-sidebar__footer">
            <button type="button" className="btn btn-secondary" onClick={this.handleSubmit}>
              Filtrer
            </button>
          </div>
        </div>
      </div>
    )
  }
}
